import { z } from 'zod';

export const itemSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    code: z.string().max(10).optional().or(z.literal('')).transform(v => v === '' ? undefined : v),
    description: z.string().min(1, 'Description is required').max(255),
});

export type ItemFormInput = z.input<typeof itemSchema>;
export type ItemFormOutput = z.output<typeof itemSchema>;
